import {
  AdminInterestCategoriesQuery,
  AdminInterestCategoryEntity,
  AdminInterestCategoryValidator,
  ListEntityV2,
  ReorderValidator,
  V2Prefix,
  endpoints,
} from '@seaters/constants';
import { api } from '../axios-instance';

const basePath = `${V2Prefix}/${endpoints.seatersAdmin}/${endpoints.interests}/${endpoints.categories}`;

export const fetchAdminInterestCategories = (
  params: AdminInterestCategoriesQuery
): Promise<ListEntityV2<AdminInterestCategoryEntity>> =>
  api.get(basePath, { params });

export const createAdminInterestCategory = (
  body: AdminInterestCategoryValidator
): Promise<AdminInterestCategoryEntity> => api.post(basePath, body);

export const updateAdminInterestCategory = (
  id: string,
  body: AdminInterestCategoryValidator
): Promise<AdminInterestCategoryEntity> => api.put(`${basePath}/${id}`, body);

export const archiveAdminInterestCategory = (
  id: string
): Promise<AdminInterestCategoryEntity> => api.delete(`${basePath}/${id}`);

export const reorderAdminInterestCategories = (
  body: ReorderValidator
): Promise<void> => api.put(`${basePath}/${endpoints.order}`, body);
